import { formatDate } from '@angular/common';
import { Pipe, PipeTransform, inject } from '@angular/core';
import { isValid, parseISO } from 'date-fns';
import { LanguageRepository } from '@app-core/state/language.repository';

@Pipe({
  standalone: true,
  name: 'customDate',
  pure: false,
})
export class CustomDatePipe implements PipeTransform {
  private readonly languageRepo = inject(LanguageRepository);

  transform(
    value: string | Date,
    format: string = 'mediumDate',
    timezone?: string,
  ): string | null {
    try {
      if (!value) return '';
      if (typeof value === 'string' && !isValid(parseISO(value))) return value;

      return formatDate(
        value,
        format,
        this.languageRepo.getActiveLanguageCodeOrDefaultCode(),
        timezone,
      );
    } catch {
      return '';
    }
  }
}
